import type { NextApiRequest } from 'next';
import { useQuery } from '@tanstack/react-query';
import type { GeneralQueryParams } from '@y2/api-clients/yad1';

import { projectFetcher } from './project-fetcher';

export const getYad1ProjectsOptions = (
  params: GeneralQueryParams,
  options = {},
  reqHeaders?: NextApiRequest['headers'],
) => {
  return {
    queryKey: ['yad1-projects', params],
    queryFn: () =>
      projectFetcher(params, reqHeaders).then((res) => res.data.data),
    retry: false,
    keepPreviousData: true,
    ...options,
  };
};

export const useYad1Projects = (params: GeneralQueryParams, options = {}) =>
  useQuery(getYad1ProjectsOptions(params, options));
